"use strict";
var core_1 = require('@angular/core');
var moment = require('moment');
// under systemjs, moment is actually exported as the default export, so we account for that
var momentConstructor = moment.default || moment;
var ParsePipe = (function () {
    function ParsePipe() {
    }
    ParsePipe.prototype.transform = function (value, format) {
        return moment(value, format);
    };
    ParsePipe.decorators = [
        { type: core_1.Pipe, args: [{ name: 'amParse' },] },
    ];
    /** @nocollapse */
    ParsePipe.ctorParameters = [];
    return ParsePipe;
}());
exports.ParsePipe = ParsePipe;
//# sourceMappingURL=parse.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-moment/parse.pipe.js
// module id = 400
// module chunks = 3